import { render, staticRenderFns } from "./ActivitiesSheets.vue?vue&type=template&id=20f2a777"
import script from "./ActivitiesSheets.vue?vue&type=script&lang=js"
export * from "./ActivitiesSheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports